import React from "react";
import { useUsmAuth } from "@/contexts/UsmAuthContext";

/**
 * <Can perm="inventory.edit">…</Can>
 * Renders children only if the current USM employee has the permission.
 * Optionally renders a `fallback` if not.
 */
export default function Can({ perm, anyOf, allOf, fallback = null, children }) {
  const { hasPerm } = useUsmAuth();
  let ok = false;
  if (perm) ok = hasPerm(perm);
  else if (anyOf && anyOf.length) ok = anyOf.some((p) => hasPerm(p));
  else if (allOf && allOf.length) ok = allOf.every((p) => hasPerm(p));
  if (!ok) return fallback;
  return <>{children}</>;
}
